import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('elite-user-selection'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
